export default "__VITE_ASSET__BRHFqhF7__"